// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2q9NX","info":"Note_info__3FXFo","note":"Note_note__1mSBf","actions":"Note_actions__tGPbd"};